import axios from "axios";

export default {
    name: 'logs',
    state: {
        logs: [],
    },
    getters: {
        getLogs: (state) => state.logs,
    },
    mutations: {
        setLogs :(state, logs) => state.logs = logs,
    },
    actions: {
        async getAppLogs(context, payload) {
            return axios.get(localApiLogs + `?limit=${payload.limit}`)
                .then((response) => response.data)
                .catch(err =>errorHandler.tomcatError(err));
        },
        async fetchLogsBydateRange(context, payload) {
            return axios.get(localApiLogs + '/get-by-date-and-appname', payload)
                .then((response) => response.data)
                .catch(err => errorHandler.tomcatError(err));
        },

        async fetchAppNamesList()  {
            return axios.get(localApiLogs + '/app-names')
                .then((response) => response.data)
                .catch(err => errorHandler.tomcatError(err));
        }
    },
};